<div class="main">
    <div class="container-fluid">
        <div class="vendors-header d-flex flex-wrap justify-content-between align-items-center m-4">
            <div class="vendors-title-container mb-3 mb-md-0">
                <h3>Manage Vendors</h3>
                <span>
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="vendors-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span class="vendors-header-title"> Manage Vendors</span>
                </span>
            </div>
            <button type="button" class="btn export-btn" (click)="exportVendors()"
                [disabled]="isLoading || isExporting || !vendors.length" [attr.aria-busy]="isExporting" title="Export all vendors, including all pages">
                <i class="pi pi-file-excel" aria-hidden="true"></i>
                {{ isExporting ? 'Exporting Vendors...' : 'Export All Vendors to Excel' }}
            </button>
        </div>

        <app-data-table
            [data]="vendors"
            [columns]="tableColumns"
            [paginator]="true"
            [rows]="10"
            [showCheckbox]="false"
            (onActionClick)="onTableActionClick($event)">
        </app-data-table>
    </div>
</div>
